import { render, staticRenderFns } from "./XiangMu2_获嘉版本.vue?vue&type=template&id=72251520&scoped=true"
import script from "./XiangMu2_获嘉版本.vue?vue&type=script&lang=js"
export * from "./XiangMu2_获嘉版本.vue?vue&type=script&lang=js"
import style0 from "./XiangMu2_获嘉版本.vue?vue&type=style&index=0&id=72251520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72251520",
  null
  
)

export default component.exports